import { memo, useContext, useRef } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import play from "bodycodi/cmap/app/svg/video_play_button.svg";
import delete1 from "bodycodi/cmap/app/img/delete-white.png";

// types
import { RenderVideosProps } from "./types";

// utils
import { isEmpty } from "bodycodi/cmap/app/js/common";

const RenderVideos = ({ videoFiles, setVideoFiles }: RenderVideosProps) => {
  const { dispatch } = useContext(DispatchContext);
  const ref = useRef<any>(null);

  const clickVideo = (e: any) => {
    e.stopPropagation();
    if (e.currentTarget.querySelector("video").paused) {
      e.currentTarget.querySelector("video").play();
    } else {
      e.currentTarget.querySelector("video").pause();
    }
  };

  const handleDelete = (e: any, i: number) => {
    e.stopPropagation();

    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: "D",
        redYn: true,
        header: "컨텐츠 삭제",
        body: "해당 컨텐츠를 \n삭제하시겠습니까?",
        cancelAlert: () => {},
        closeAlert: () => {
          const list = videoFiles.filter((d: any, index: number) => {
            return i !== index;
          });
          setVideoFiles([...list]);
        },
      },
    });
  };

  return (
    <>
      {videoFiles?.map((video: any, index: number) => {
        const videoUrl: any = !isEmpty(video.fileUrl)
          ? video.fileUrl
          : (window.URL || window.webkitURL).createObjectURL(video.fileData);

        const thumbNail = !isEmpty(video.thumbNail) ? video.thumbNail : null;

        return (
          <div className="file-handler" key={index}>
            <div className="preview video" onClick={clickVideo} ref={ref}>
              <video poster={thumbNail}>
                <source src={videoUrl} />
              </video>
              <div className="video-play">
                <div className="play-btn">
                  <img src={play} />
                </div>
              </div>
            </div>
            <div className="btn-wrap">
              <div className="btn1" onClick={(e) => handleDelete(e, index)}>
                <img src={delete1} />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default memo(RenderVideos);
